import {
  GeneralObject,
  TMinOQListResponse,
  TMOQListPayload,
  TDeleteMinOQPayload,
  TGetMinOQByIdResponse,
} from '../utils/types';
import { emptySplitApi } from './emptySplitApi';
import { createTokenHeader } from '../utils/functions/headers';

export const minoqService = emptySplitApi
  .enhanceEndpoints({
    addTagTypes: ['MinOQList'],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      getAllMinOQList: builder.query<
        { data: TMinOQListResponse[]; totalCount: number },
        TMOQListPayload
      >({
        query: (params) => ({
          method: 'GET',
          url: `product/minimumorderqty/list`,
          params,
        }),
        transformResponse: (
          data: TMinOQListResponse[],
          meta: Response
        ) => {
          const totalCount =
            meta.headers.get('X-total-count');
          return {
            data,
            totalCount: Number(totalCount ? totalCount : 0),
          };
        },
        providesTags: ['MinOQList'],
      }),
      MinOQExport: builder.mutation({
        query: (data) => ({
          url: `products/minimumorderqty/export`,
          method: 'POST',
          data: data,
        }),
      }),
      minOQImport: builder.mutation({
        query: ({ data, companyId }) => ({
          url: `products/minimumorderqty/import/${companyId}`,
          method: 'POST',
          data: data,
          headers: createTokenHeader(),
        }),
        invalidatesTags: ['MinOQList'],
      }),
      deleteMinOQ: builder.mutation<
        GeneralObject,
        TDeleteMinOQPayload
      >({
        query: (data) => {
          return {
            url: 'products/minimumorderqty/delete',
            method: 'POST',
            data,
          };
        },
        invalidatesTags: ['MinOQList'],
      }),
      getMinOQDetails: builder.query<
        TGetMinOQByIdResponse,
        number
      >({
        query: (minOQId) => ({
          url: `product/minimumorderqty/${minOQId}`,
          method: 'GET',
        }),
      }),
      addUpdateMinOrderableQty: builder.mutation<
        GeneralObject,
        GeneralObject
      >({
        query: (data) => ({
          url: 'products/minimumorderqty/update',
          method: 'POST',
          data,
        }),
        invalidatesTags: ['MinOQList'],
      }),
    }),
  });

export const {
  useGetAllMinOQListQuery,
  useDeleteMinOQMutation,
  useMinOQExportMutation,
  useMinOQImportMutation,
  useGetMinOQDetailsQuery,
  useAddUpdateMinOrderableQtyMutation,
} = minoqService;
